import { SHOP_FOLLOW_SET, SHOP_FOLLOW_SYNC } from '../action-types/shop-follow.action-types';

export type ShopFollowReducer = {
  byOwnerId: Record<number, boolean>;
};

const initialState: ShopFollowReducer = {
  byOwnerId: {},
};

const shopFollowReducer = (state = initialState, action): ShopFollowReducer => {
  switch (action.type) {
    case SHOP_FOLLOW_SET: {
      return {
        ...state,
        byOwnerId: { ...state.byOwnerId, [action.ownerId]: action.liked },
      };
    }
    case SHOP_FOLLOW_SYNC: {
      return {
        ...state,
        byOwnerId: { ...state.byOwnerId, ...action.entries },
      };
    }
    default: {
      return state;
    }
  }
};

export default shopFollowReducer;
